/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminAppointedVisitDto
 */
export interface AdminAppointedVisitDto {
    /**
     * 
     * @type {string}
     * @memberof AdminAppointedVisitDto
     */
    'appointedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAppointedVisitDto
     */
    'insertionTime': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminAppointedVisitDto
     */
    'isPaid': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminAppointedVisitDto
     */
    'patientName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAppointedVisitDto
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAppointedVisitDto
     */
    'timeFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAppointedVisitDto
     */
    'visitStatus'?: AdminAppointedVisitDtoVisitStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminAppointedVisitDto
     */
    'visitType'?: AdminAppointedVisitDtoVisitTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AdminAppointedVisitDtoVisitStatusEnum {
    Done = 'DONE',
    Cancelled = 'CANCELLED',
    Additional = 'ADDITIONAL',
    ToMove = 'TO_MOVE'
}
/**
    * @export
    * @enum {string}
    */
export enum AdminAppointedVisitDtoVisitTypeEnum {
    Remote = 'REMOTE',
    Stationary = 'STATIONARY',
    Absent = 'ABSENT'
}


